export default __webpack_public_path__ + "d4e67b381b07b2f246d309f5660768b3.svg";